import React from 'react';
import {host} from '@/utils/hostConf';
import './index.less';
import {locationTo, getArrProp} from '@/utils/tools';

const DoctorCard = ({doctorInfo}) => {
  const {
    doctor_img,
    doctor_name,
    doctor_hospital,
    doctor_title,
    honor,
    doc2dept_list,
    treat_num,
    dept_no,
    doc2shop_list,
    doctor_id,
  } = doctorInfo;
  const convert_treat_num = treat_num >= 10000 ? (treat_num / 10000).toFixed(1) + '万' : treat_num;
  const mis_doctor_id = getArrProp(doc2shop_list, 'mis_doc_id').join('_');
  const docLink = `/doctorinfo/${doctor_id}/${mis_doctor_id ? mis_doctor_id : ''}${
    dept_no ? `?dept_no=${dept_no}` : ''
  }`;
  let doctor_hos = doctor_hospital || doc2shop_list[0].shop_name;

  return (
    <div className="doctor-item" onClick={() => locationTo(docLink)}>
      <div className="doctor-item-left">
        <div className="doctor-info">
          <img className="doctor-headimg" src={`${host.dr_img + doctor_img}`} alt="" />
          <div className="doctor-name">
            <span>{doctor_name}</span>
            {honor && <span className="doctor_title">{honor}</span>}
          </div>
          <div className="doctor-position">{doctor_title}</div>
          <div className="doctor-hospital">{doctor_hos + ' ' + doc2dept_list.map(d => d.dept_name).join('、')}</div>
        </div>
      </div>
      <div className="doctor-item-right">
        {/* <div className="treat">
          <span className="treat-num">{convert_treat_num}</span>
          <span>接诊量</span>
        </div> */}
      </div>
    </div>
  );
};

export default DoctorCard;
